export default __webpack_public_path__ + "static/media/tradingEth.1420a3ac.svg";